module.exports = __webpack_public_path__ + "img/energy_center_pic.6ce2499f.png";